import React, { useRef,useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import SearchFiltersPanel from './SearchFiltersPanel';
import { Button, Badge, notification, Input, Space,message, Col,Row, Popconfirm, Spin, Tooltip } from 'antd';
import { SearchOutlined,PlayCircleFilled, StopOutlined, CheckOutlined, CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NonSubIcon, SubIcon , NeverSubIcon} from '../common/CustomerIcons';
import { faFileExport, faPen } from '@fortawesome/free-solid-svg-icons';
import { CommonTable } from '../common';
import OgmSubsMobile  from '../manage-subs/OgmSubsMobile';
import { BOS_SEARCH_CONDITION_KEY, CONST_PAGINATION_TEN, DATE_TIME_ONE_FORMAT, DATE_TIME_TWO_FORMAT } from '../../common/constants';
import {
  useFetchOgmSubsData, useResetOgmSubsData, useSaveSearchConditionData, useExportOgmSubsData, useUpdateSubstitutionsData,
  useDeleteManageSubs,useFetchRecommendedProducts,useResetRecommendedProducts,useResetSubstituteProducts,
} from './redux/hooks';
import { useRetainConditionData } from './redux/hooks';
import { renderTableColumns } from '../../common/renderColumns';
import { useGetOgmSubstitutionsData } from './redux/getOgmSubstitutionsData';
import moment from 'moment';
import _ from 'lodash';
import { CONST_OGM_SUBS_TABLE_PARENT_COLUMNS,CONST_OGM_SUBS_TABLE_EXPANDED_COLUMNS } from '../../common/ogmSubsConstants';
import OgmSubsOperateModal from './OgmSubsOperateModal';
// import OgmSubsOperateModalMobile from './OgmSubsOperateModalMobile';  //Hide for Phase 1 Mobile
import { CORP_USER_LIST } from '../../common/corpProfile';
import { CONST_SUB_RULE_TYPE, CONST_NONE_SUB_RULE_TYPE,CONST_NEVER_SUB_RULE_TYPE, CONST_DROP_OUT_RULE_TYPE } from '../../common/manageSubsConstants';
import { uniqueTerritoryList } from './getOriginalSelectedList';
import { formatTerrirotyData } from './formattedSearchCondition';
import { datadogRum } from '@datadog/browser-rum';
import { useResponsive } from './useResponsive';
import { validateNumericRegExp } from './formattedSubsData';
export default function OgmSubs() {
  const {
    ogmSubsData,
    searchConditionData,
    fetchOgmSubsDataPending,
    territoryData,
    userId,
    originalList,
    userName,
    exportOgmSubsDataPending,
    updateSubstitutionsDataPending,
    conditionData,
    user,
    exportOgmSubsDataError,
  } = useSelector(state => ({
    ogmSubsData: state.manageSubs.ogmSubsData,
    searchConditionData: state.manageSubs.searchConditionData,
    fetchOgmSubsDataPending: state.manageSubs.fetchOgmSubsDataPending,
    territoryData: state.dashboard.territoryData,
    userId: state.home.auth.user.userId,
    conditionData: state.manageSubs.conditionData,
    originalList: state.manageSubs.originalList,
    userName: state.home.auth.user.userName,
    exportOgmSubsDataPending: state.manageSubs.exportOgmSubsDataPending,
    updateSubstitutionsDataPending: state.manageSubs.updateSubstitutionsDataPending,
    user: state.home.auth.user,
    exportOgmSubsDataError: state.manageSubs.exportOgmSubsDataError,
  }));
  const { resetSubstituteProducts } = useResetSubstituteProducts();
  const { resetRecommendedProducts } = useResetRecommendedProducts();
  const { fetchRecommendedProducts } = useFetchRecommendedProducts();
  const { fetchOgmSubsData } = useFetchOgmSubsData();
  const { exportOgmSubsData } = useExportOgmSubsData();
  const { resetOgmSubsData } = useResetOgmSubsData();
  const { saveSearchConditionData } = useSaveSearchConditionData();
  const [resetActivePagination, setResetActivePagination] = useState(false);
  const { retainConditionData } = useRetainConditionData();
  const { getOgmSubstitutionsData } = useGetOgmSubstitutionsData();
  const [isOgmSubsModalVisible, setOgmSubsModalVisible] = useState(false);
  const [editableData, setEditableData] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [substituteItemSearch, setSubstituteItemSearch] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const { updateSubstitutionsData } = useUpdateSubstitutionsData();
  const { deleteManageSubs } = useDeleteManageSubs();
  const [title, setModelTitle] = useState('');
  const { isMobile } = useResponsive(800);
  const location = useLocation();
  const storagedCondition = JSON.parse(sessionStorage.getItem(BOS_SEARCH_CONDITION_KEY));
  const [storagedConditionState, setStoragedConditionState] = useState(() =>
    JSON.parse(sessionStorage.getItem(BOS_SEARCH_CONDITION_KEY)) || {}
  );
  const [pagination, setPagination] = useState(() => {
      const storedPageSize = sessionStorage.getItem('pageSize');
      const storedPageIndex = sessionStorage.getItem('pageIndex');
      return {
        pageIndex: storedPageIndex ? parseInt(storedPageIndex, 10) : CONST_PAGINATION_TEN.pageIndex,
        pageSize: storedPageSize ? parseInt(storedPageSize, 10) : CONST_PAGINATION_TEN.pageSize,
      };
    });
    useEffect(() => {
      // Reset pagination state on route change
      setPagination({
        pageIndex: CONST_PAGINATION_TEN.pageIndex,
        pageSize: CONST_PAGINATION_TEN.pageSize,
      });
    }, [location.pathname]);
  useEffect(() => {
    setStoragedConditionState(JSON.parse(sessionStorage.getItem(BOS_SEARCH_CONDITION_KEY)) || {});
  }, [location.pathname, searchText, substituteItemSearch]);

  useEffect(() => {
    if (storagedConditionState) {
      let value = '';
      if (storagedConditionState.originalItem && /^\d+$/.test(storagedConditionState.originalItem)) {
        value = storagedConditionState.originalItem;
      } else if (storagedConditionState.originalItemDescription) {
        value = storagedConditionState.originalItemDescription;
      }
      if (value) setSearchText(value);

      let subValue = '';
      if (storagedConditionState.substituteItem && /^\d+$/.test(storagedConditionState.substituteItem)) {
        subValue = storagedConditionState.substituteItem;
      } else if (storagedConditionState.substituteItemDescription) {
        subValue = storagedConditionState.substituteItemDescription;
      }
      if (subValue) setSubstituteItemSearch(subValue);
    }
  }, [storagedConditionState]);
  const renderParentElement = [
    { //render siteID
      extendRender: (value, label, record) => {
        return (
          <>
            <div className="col-title">{value}</div>
            <div className="col-desc">{record.siteDesc}</div>
          </>
        )
      }
    },
    { //render conceptID
      extendRender: (value, label, record) => {
        if(value && value.length > 0) {
          return (
            <>
              <div className="col-title">{value}</div>
              <div className="col-desc">{record.nationalName}</div>
            </>
          )
        }
        return (
          <>
            <div className="col-title">{record.customerNumber}</div>
            <div className="col-desc">{record.customerName}</div>
          </>
        )
      }
    },
    { //render originalItem
      extendRender: (value, label, record) => {
        let originalItemDetails = ``;
        if(value) {
          // originalItemDetails = `${record.originalItemDescription} <br/> ${record.originalUom} | ${record.originalPack}/${record.originalSize} | ${record.originalBrand} | ${record.originalStorageCode}`;
          originalItemDetails = `${record.originalUom} | ${record.originalPack}/${record.originalSize} | ${record.originalBrand} | ${record.originalStorageCode}`;
        }
        let category = record.itemCategory
        let categoryIcon = ''
        if(category) {
          category = category.trim()
          categoryIcon = category === 'C' ? <Badge className="sub-badge-item" color="#7AC943"/>
            : category === 'D' ? <Badge className="sub-badge-item" color="#FF931E"/>
            : category === 'B' ? <Badge className="sub-badge-item" color="#FFFF00"/>
            : category === 'A' ? <Badge className="sub-badge-item" color="#FF1022"/>
            : <span className="blank-badge" />
        } else {
          categoryIcon = <span className="blank-badge" />
        }
        return (
          <>
            <div className="col-title">
              {categoryIcon}
              {value}
            </div>
            <div className="col-desc handle-overflow detail-info">{record.originalItemDescription}</div>
            <div className="col-desc handle-overflow detail-info">{originalItemDetails}</div>
          </>
        )
      }
    },
    { //render subItem
      extendRender: (value, label, record) => {
        
        let subItemDetails = ``;
        let description=''

        if(value && value !== 'Multiple') {
          // subItemDetails = `${record.substituteItemDescription} | ${record.substituteUom} | ${record.substitutePack}/${record.substituteSize} | ${record.substituteBrand} | ${record.substituteStorageCode}`;
          subItemDetails = `${record.substituteUom} | ${record.substitutePack}/${record.substituteSize} | ${record.substituteBrand} | ${record.substituteStorageCode}`;
        }
        if(record.ruleType===CONST_NEVER_SUB_RULE_TYPE){
         description= <div className="col-desc handle-overflow">NEVER SUB</div>;
        }
        else{
          description=<div className="col-desc handle-overflow">{record.substituteItemDescription}</div>;
        }
        // if((value==='' && ( record.ruleType===CONST_SUB_RULE_TYPE || record.ruleType===CONST_NONE_SUB_RULE_TYPE) )|| record.ruleType==='dropout'){
        //COT-5289,dropout rule will returned as dropout rule type
        if(record.ruleType === CONST_DROP_OUT_RULE_TYPE){ 
          description= <div className="col-desc handle-overflow">DROPOUT</div>;
        }
        return (
          <>
            <Row>
              <Col span={3} className='flex align-items-center' style={{justifyContent:'center'}}>
                {record.ruleType === CONST_SUB_RULE_TYPE ? <SubIcon style={{ fontSize: '16px', color: '#7ac943' }} /> : record.ruleType === CONST_NONE_SUB_RULE_TYPE ? <NonSubIcon style={{ fontSize: '19px', color: '#db6f6f' }} /> : record.ruleType === CONST_NEVER_SUB_RULE_TYPE?<NeverSubIcon style={{ fontSize: '16px', color: '#db6f6f' }} />: record.ruleType === CONST_DROP_OUT_RULE_TYPE ?<PlayCircleFilled  rotate={90} style={{ fontSize: '16px', color: '#db6f6f'  }}/>:null}
              </Col>
              <Col span={21}>
                <div className="col-title">{value}</div>
                {description}
                <div className="col-desc  handle-overflow">{subItemDetails}</div>
              </Col>
            </Row>
          </>
        )
      }
    },
    {//render sub ratio
      extendRender: (value, label, record) => {
        if (record.ruleType === CONST_DROP_OUT_RULE_TYPE || record.ruleType === CONST_NONE_SUB_RULE_TYPE) {
          return (
            <>
              <div className="col-title">{record.reasonCode}</div>
              <div className="col-desc">{record.reasonDescription}</div>
            </>
          )
        } else {
          return value;
        }
      }                   
    },
    {},//endDate placeholder
    {},//lastOrderDate placeholder
    { //render modifiedBy
      extendRender: (value, label, record) => {
       
         const modifiedDate = record.modifiedTimestamp && moment(record.modifiedTimestamp).format(DATE_TIME_ONE_FORMAT);
        //const lastModifiedDate = value && moment(value).format(DATE_TIME_ONE_FORMAT);

        return value && (
          <>
            <div className="col-title">{record.modifiedByName}</div>
            <div className="col-desc">{`${record.modifiedById} ${modifiedDate}`}</div>
          </>
        )
      }
    },
    { //rerender Cust APV
      extendRender: (value, label, record) => {
        if (record.ruleType === CONST_SUB_RULE_TYPE || record.ruleType === CONST_NONE_SUB_RULE_TYPE) {
          if(!_.isEmpty(record?.expandedItems) && record?.expandedItems[0]?.customerApprovalFlag){
            return (
              <>
                <CheckOutlined style={{ fontSize: '16px', color: '#6b6b6c' }} />
              </>
            )
          }
        }
      }
    },
  ];
  const renderExpandedElement = [
    {}, //priority placeholder
    { //render subItem
      extendRender: (value, label, record) => {
        let subItemDetails = ``;
        if(value) {
          subItemDetails = `${record.substituteUom} | ${record.substitutePack}/${record.substituteSize} | ${record.substituteBrand} | ${record.substituteStorageCode}`;
        }
        return (
          <>
            <Row>
              <Col span={3} className='flex align-items-center' >
                {record.ruleType === CONST_SUB_RULE_TYPE ? <SubIcon style={{ fontSize: '16px', color: '#7ac943' }} /> : record.ruleType === CONST_NONE_SUB_RULE_TYPE ? <NonSubIcon style={{ fontSize: '19px', color: '#db6f6f' }} /> :record.ruleType === CONST_NEVER_SUB_RULE_TYPE?<NeverSubIcon style={{ fontSize: '16px', color: '#db6f6f' }} />: record.ruleType === CONST_DROP_OUT_RULE_TYPE ?<PlayCircleFilled  rotate={90} style={{ fontSize: '16px', color: '#db6f6f'  }}/>:null}
                {/* {record.ruleType === CONST_SUB_RULE_TYPE ? <SubIcon style={{ fontSize: '16px', color: '#7ac943' }} /> : record.ruleType === CONST_NONE_SUB_RULE_TYPE ? <NonSubIcon style={{ fontSize: '19px', color: '#db6f6f' }} /> : null} */}
              </Col>
              <Col span={21}>
                <div className="col-title">{value}</div>
                {record.ruleType === CONST_DROP_OUT_RULE_TYPE ? <div className="col-desc handle-overflow">DROPOUT</div> : <div className="col-desc">{record.substituteItemDescription}</div>}
                <div className="col-desc">{subItemDetails}</div>
              </Col>
            </Row>
          </>
        )
      }
    },
    {
      extendRender: (value, label, record) => {
        if (record.ruleType === CONST_DROP_OUT_RULE_TYPE || record.ruleType === CONST_NONE_SUB_RULE_TYPE) {
          return (
            <>
              <div className="col-title">{record.reasonCode}</div>
              <div className="col-desc">{record.reasonDescription}</div>
            </>
          )
        } else {
          return value;
        }
      }
    }, //reasonCode placeholder
    {}, //subRatio placeholder
    {}, //endDate placeholder
     // { //render createBy
    //   extendRender: (value, label, record) => {
    //     const createdDate = record.createTimestamp && moment(record.createTimestamp).format(DATE_TIME_ONE_FORMAT);
    //     return value && (
    //       <>
    //         <div className="col-title">{value}</div>
    //         <div className="col-desc">{`${record.createdById} ${createdDate}`}</div>
    //       </>
    //     )
    //   }
    { //rerender lastModified
      extendRender: (value, label, record) => {
        const lastModifiedDate = value && moment(value).format(DATE_TIME_ONE_FORMAT);
        return value && (
          <>
            <div className="col-title">{record.modifiedByName}</div>
            <div className="col-desc">{`${record.modifiedById} ${lastModifiedDate}`}</div>
          </>
        )
      }
    },
    { //rerender Cust APV
      extendRender: (value, label, record) => {
        if(value){
          return (
            <>
              <CheckOutlined style={{ fontSize: '16px', color: '#6b6b6c' }} />
            </>
          )
        }
      }
    }
  ]
  const inputRef = useRef();
  const initializedRef = useRef(false);
  let searchForm = null;
  let clearFiltersRef = null;
  let confirmRef = null;
  const handleTerritoryParam = (values) => {
    let isCorpProfileUser = false
    if(originalList.length === 0) {
      const user = CORP_USER_LIST.filter(item => item.userId === userId);
      if (!_.isEmpty(user)) {
        isCorpProfileUser = true
      }
    }
    if((territoryData && ((territoryData.role && territoryData.role.toLowerCase() === 'corp') || _.isEmpty(territoryData.role))) || isCorpProfileUser) {
      let temp = values.territoryInfoList ? values.territoryInfoList.trim() : ''
      if(temp) {
        return [{"terrName": temp}]
      }else {
        return []
      }
    }else {
      return values.territoryInfoList !== undefined && values.territoryInfoList !== null ? uniqueTerritoryList(formatTerrirotyData(values, territoryData)) : null
    }
  }
  
  const handleOriginalItemSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  const formVals = searchForm?.getFieldsValue ? searchForm.getFieldsValue() : {};
  let conceptOrCustomer = '';
  if (formVals && formVals.conceptOrCustomer !== undefined) {
    if (Array.isArray(formVals.conceptOrCustomer) && formVals.conceptOrCustomer.length > 0) {
      conceptOrCustomer = formVals.conceptOrCustomer[0];
    } else {
      conceptOrCustomer = formVals.conceptOrCustomer;
    }
  }
  const storagedCondition = JSON.parse(sessionStorage.getItem(BOS_SEARCH_CONDITION_KEY)) || {};
  let searchVal = '';

  if (storagedCondition.originalItem) {
    searchVal = storagedCondition.originalItem;
  } else if (storagedCondition.originalItemDescription) {
    searchVal = storagedCondition.originalItemDescription;
  } else {
    searchVal = selectedKeys[0] || '';
  }

  const isNumeric = /^\d+$/.test(searchVal);
  if (formVals && formVals.sites && formVals.sites.length > 0) {
    delete formVals.originalItem;
    delete formVals.originalItemDescription;

    let sessionObj = {
      ...formVals,
      conceptOrCustomer,
      ruleType: formVals.ruleType !== undefined ? formVals.ruleType : 'all',
      territoryInfoList: handleTerritoryParam(formVals),
    };
    if (isNumeric) {
      sessionObj.originalItem = searchVal;
      delete sessionObj.originalItemDescription;

    } else {
      sessionObj.originalItemDescription = searchVal;
      delete sessionObj.originalItem;

    }
    sessionStorage.setItem(BOS_SEARCH_CONDITION_KEY, JSON.stringify(sessionObj));
    saveSearchConditionData(sessionObj);
    retainConditionData({ ...conditionData, ...sessionObj });

    setSearchText(searchVal);
    setSearchedColumn(dataIndex);
  } else {
    message.error('Please select Site!')
  }
};
  const handleOriginalItemReset = (clearFilters, confirm, dataIndex) => {
    const condition = { ...conditionData };
    delete condition.originalItem;
    delete condition.originalItemDescription;
    retainConditionData({ ...condition });
    setSearchText('');
    clearFilters();
    confirm({ closeDropdown: true });
    setSearchedColumn(dataIndex);
    const formVals = searchForm.getFieldsValue()
    if(formVals && formVals.sites && formVals.sites.length > 0) {
      const conceptOrCustomer = Array.isArray(formVals.conceptOrCustomer) && formVals.conceptOrCustomer.length > 0
      ? formVals.conceptOrCustomer[0]
      : formVals.conceptOrCustomer;
      saveSearchConditionData({
        ...formVals,
        conceptOrCustomer: conceptOrCustomer,
        ruleType: formVals.ruleType !== undefined ? formVals.ruleType : 'all',
        territoryInfoList: handleTerritoryParam(formVals),
      });
    } else {
      message.error('Please select Site!')
    }
  };
  const originalItemSearchReset = () => {
    setSearchText('');
    if(clearFiltersRef) {
      clearFiltersRef()
    }
    if(confirmRef) {
      confirmRef({
        closeDropdown: true,
      });
    }
  };

  const handleInputChg = (e, dataIndex, setSelectedKeys, setSearchValue) => {
    const val = e.target.value;
    setSelectedKeys(val ? [val] : []);
    setSearchValue(val);

    // Clear both fields if input is empty
    if (dataIndex === 'originalItem') {
      if (val === '') {
        retainConditionData({ ...conditionData, originalItem: '', originalItemDescription: '' });
      } else if (/^\d+$/.test(val)) {
        retainConditionData({ ...conditionData, originalItem: val, originalItemDescription: '' });
      } else {
        retainConditionData({ ...conditionData, originalItem: '', originalItemDescription: val });
      }
    } else if (dataIndex === 'substituteItem') {
      if (val === '') {
        retainConditionData({ ...conditionData, substituteItem: '', substituteItemDescription: '' });
      } else if (/^\d+$/.test(val)) {
        retainConditionData({ ...conditionData, substituteItem: val, substituteItemDescription: '' });
      } else {
        retainConditionData({ ...conditionData, substituteItem: '', substituteItemDescription: val });
      }
    } else {
      retainConditionData({ ...conditionData, [dataIndex]: val });
    }
  };

  const handleSubstituteItemSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    const formVals = searchForm?.getFieldsValue ? searchForm.getFieldsValue() : {};
    let conceptOrCustomer = '';
    if (formVals && formVals.conceptOrCustomer !== undefined) {
      if (Array.isArray(formVals.conceptOrCustomer) && formVals.conceptOrCustomer.length > 0) {
        conceptOrCustomer = formVals.conceptOrCustomer[0];
      } else {
        conceptOrCustomer = formVals.conceptOrCustomer;
      }
    }
    const storagedCondition = JSON.parse(sessionStorage.getItem(BOS_SEARCH_CONDITION_KEY)) || {};
    let searchVal = '';

    if (storagedCondition.substituteItem) {
      searchVal = storagedCondition.substituteItem;
    } else if (storagedCondition.substituteItemDescription) {
      searchVal = storagedCondition.substituteItemDescription;
    } else {
      searchVal = selectedKeys[0] || '';
    }

    const isNumeric = /^\d+$/.test(searchVal);
    if (formVals && formVals.sites && formVals.sites.length > 0) {
      // Remove both fields before setting
      delete formVals.substituteItem;
      delete formVals.substituteItemDescription;

      let sessionObj = {
        ...formVals,
        conceptOrCustomer,
        ruleType: formVals.ruleType !== undefined ? formVals.ruleType : 'all',
        territoryInfoList: handleTerritoryParam(formVals),
      };

      if (isNumeric) {
        sessionObj.substituteItem = searchVal;
        if ('substituteItemDescription' in sessionObj) delete sessionObj.substituteItemDescription;
      } else {
        sessionObj.substituteItemDescription = searchVal;
        if ('substituteItem' in sessionObj) delete sessionObj.substituteItem;
      }

      sessionStorage.setItem(BOS_SEARCH_CONDITION_KEY, JSON.stringify(sessionObj));
      saveSearchConditionData(sessionObj);
      retainConditionData({ ...conditionData, ...sessionObj });

      setSubstituteItemSearch(searchVal);
      setSearchedColumn(dataIndex);
    } else {
      message.error('Please select Site!');
    }
  };
  const handleSubstituteItemReset = (clearFilters, confirm, dataIndex) => {
    const condition = { ...conditionData };
    delete condition.substituteItem;
    delete condition.substituteItemDescription;
    retainConditionData({ ...condition });
    setSubstituteItemSearch('');
    clearFilters();
    confirm({ closeDropdown: true });
    setSearchedColumn(dataIndex);

    const formVals = searchForm.getFieldsValue();
    if (formVals && formVals.sites && formVals.sites.length > 0) {
      saveSearchConditionData({
        ...formVals,
        ruleType: formVals.ruleType !== undefined ? formVals.ruleType : 'all',
        territoryInfoList: handleTerritoryParam(formVals),
      });
    } else {
      message.error('Please select Site!');
    }
  };

  const substituteItemSearchReset = () => {
    setSubstituteItemSearch('');
    if (clearFiltersRef) clearFiltersRef();
    if (confirmRef) confirmRef({ closeDropdown: true });
  };

  const getColumnSearchProps = (dataIndex, searchHandler, resetHandler, searchValue, setSearchValue, setterName) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
      clearFiltersRef = clearFilters;
      confirmRef = confirm;
      const placeholder =
        dataIndex === 'originalItem'
          ? 'Search ItemNumber/Description'
          : dataIndex === 'substituteItem'
            ? 'Search SubItem or Description'
            : `Search ${dataIndex}`;
      return (
        <div style={{ padding: 8 }}>
          <Input
            className="ogm-search-input"
            ref={inputRef}
            placeholder={placeholder}
            value={searchValue}
            onChange={e => handleInputChg(e, dataIndex, setSelectedKeys, setSearchValue)}
            onPressEnter={() => searchHandler(selectedKeys, confirm, dataIndex)}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => searchHandler(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Search
            </Button>
            <Button onClick={() => resetHandler(clearFilters, confirm, dataIndex)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
          </Space>
        </div>
      )
    },
    filterIcon: filtered => (<SearchOutlined style={{ fontSize: '16px', color: searchValue ? 'blue' : '#bfbfbf', }} />),
    filteredValue: searchValue ? [searchValue] : [],
    onFilter: () => true,
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => {
          // eslint-disable-next-line no-unused-expressions
          inputRef.current?.select();
        }, 100);
      }
    },
  });
  const searchFormCb = (form) => {
    searchForm = form;
  };
  let expandedColumns = renderTableColumns(CONST_OGM_SUBS_TABLE_EXPANDED_COLUMNS, null, renderExpandedElement);
  const columns = [
    ...CONST_OGM_SUBS_TABLE_PARENT_COLUMNS.slice(0, 2),
    {
      ...CONST_OGM_SUBS_TABLE_PARENT_COLUMNS[2],
      ...getColumnSearchProps('originalItem', handleOriginalItemSearch, handleOriginalItemReset, searchText, setSearchText, 'setOriginalItemKeys'),
    },
    {
      ...CONST_OGM_SUBS_TABLE_PARENT_COLUMNS[3],
      ...getColumnSearchProps('substituteItem', handleSubstituteItemSearch, handleSubstituteItemReset, substituteItemSearch, setSubstituteItemSearch, 'setSubstituteItemKeys'),
    },
    ...CONST_OGM_SUBS_TABLE_PARENT_COLUMNS.slice(4),
  ];
  //COT-10012,customized sorter
  const [sorting, setSorting] = useState({ sortedBy: null, sort: null });
  const tableColums = columns.map((col) => {
    return col.sortIndicator ? { ...col, sortOrder: sorting.sort, title: <CustomerTitle setSorting={setSorting} sorting={sorting} dataIndex={col.dataIndex} title={col.title} /> } : col
  })

let parentColumns = renderTableColumns(tableColums, null, renderParentElement);
  parentColumns.push({
    title: 'Actions',
    dataIndex: '',
    width: 60,
    render: (value, record) => {
      const isInvalidUom = String(record.invalidUom || '').toLowerCase() === 'true'; //COT-10559 need to implement for mobile code as well
      return (
        <div className="flex parent-actions" style={isInvalidUom ? { opacity: 0.6, color: '#a1a1a2' } : undefined} >
          <Button type="link" onClick={() => onEdit(record)} style={{padding: '4px 8px'}} disabled={isInvalidUom}>
            <FontAwesomeIcon icon={faPen} color='#6b6b6c' style={{ height: "15px", width: "15px" }} />
          </Button>
          {record.ruleType !== CONST_NEVER_SUB_RULE_TYPE &&
            <Popconfirm
              title="Are you sure would like to mark to never sub?"
              onConfirm={() => updateToNeverSub(record)}
              okText="Yes"
              cancelText="No"
              placement="left"
            >
              <Button title="Mark to Never Sub" type="link" style={{ padding: '4px 8px' }} disabled={isInvalidUom} >
                <StopOutlined style={{ fontSize: '16px', color: '#6b6b6c' }} />
              </Button></Popconfirm>
          } 
        </div>
      );
    }
  });
  const rowExpandable = (record) => {
    return record.expandedItems && record.expandedItems.length > 1;
  }
  const onExport = () => {
    const timing = Date.now();
    const params = { ...searchConditionData }
    params.emailId = user?.email;
    if (ogmSubsData.totals > 100000) {
      message.error(`The maximum number of rules to be exported exceeds the 100,000 record limit. Please include additional filter criteria to refine the number of records`);
      return;
    }
    if (searchText) {
      if (/^\d+$/.test(searchText)) {
        params.originalItem = searchText;
        delete params.originalItemDescription;
      } else {
        params.originalItemDescription = searchText;
        delete params.originalItem;
      }
    } else {
      delete params.originalItem;
      delete params.originalItemDescription;
    }

    // Numeric validation for substituteItem/substituteItemDescription
    if (substituteItemSearch) {
      if (/^\d+$/.test(substituteItemSearch)) {
        params.substituteItem = substituteItemSearch;
        delete params.substituteItemDescription;
      } else {
        params.substituteItemDescription = substituteItemSearch;
        delete params.substituteItem;
      }
    } else {
      delete params.substituteItem;
      delete params.substituteItemDescription;
    }
    exportOgmSubsData(params)
    .then(res => {
      // Handle 504 status (file sent to email)
      if (res && res.status === 504) {
        message.error("Export file sent to email due to large volume of data");
      } 
    })
    .catch(err => {
      if (err && err.response && err.response.status === 504) {
        message.error("Export file sent to email due to large volume of data");
      } else if (err && err.response && err.response.status !== 200 && err.response.status !== 504) {
        message.error("Something went wrong");
      } else {
        message.error('There is an error. Please refresh page or contact administrator.');
      }
    });
    datadogRum.onReady(function () {
      datadogRum.addTiming(`Download subs`, timing);
    });
  }
  
  const onEdit = (record) => {
    setEditableData(record);
    if(record && record.ruleType === null && (record.expandedItems && record.expandedItems.length === 0)) {
      setModelTitle(`Add sub rule`);
    } else {
      setModelTitle('Edit sub rule');
    }
    const storagedCondition = JSON.parse(sessionStorage.getItem(BOS_SEARCH_CONDITION_KEY)) || {};
    delete storagedCondition.substituteItem;
    delete storagedCondition.substituteItemDescription;
    sessionStorage.setItem(BOS_SEARCH_CONDITION_KEY, JSON.stringify(storagedCondition));

    const payload = {
      ...searchConditionData,
      sites: [record.site],
      customerNumber: record.customerNumber ? record.customerNumber : '',
      nationalIds: record.nationalId ? [record.nationalId] : [],
      originalItem: record.originalItem,
      ruleType: 'all',
      substituteItem: '',
      substituteItemDescription: '',
    };
    getOgmSubstitutionsData(payload).then(res => {
      if (res.data && Array.isArray(res.data) && res.data.length > 0) {
        setEditableData(res.data[0]);
        onToggleModal(setOgmSubsModalVisible);
        console.log(editableData);
        setOgmSubsModalVisible(true);
      } else {
        setEditableData(record);
        onToggleModal(setOgmSubsModalVisible);
        setOgmSubsModalVisible(true);
      }
    });

    //COT-9714,Implement drag and drop functionality for OGM Subs, need to fetch recommended products
    fetchRecommendedProducts({
      "searchBy": "Item Description",
      "searchInput": record.originalItemDescription,
      "site": [record.site],
      "originalItemUom": record.originalUom,
      "originalItem": record.originalItem,
      "nationalId": _.isEmpty(record?.nationalId) ? '' : record?.nationalId,
      "customerNumber": _.isEmpty(record?.customerNumber) ? '' : record?.customerNumber,
      "isFromOuts": false,
      "searchFor": "Recommended Products",
    }).catch(err => {
      //message.error(`Search Recommended Substitutions Failed, please try again.`);
      message.error(`${err}`); //COT-10152
    });
  }
  const onToggleModal = updateState => {
    updateState(prevState => {
      return !prevState;
    });
  }
  const updateToNeverSub = (record) => {
    const args = {
      "site": record.site,
      "siteDesc": record.siteDesc,
      "nationalId": record.nationalId ? record.nationalId : "",
      "nationalName": record.nationalName ? record.nationalName : "",
      "originalItem": record.originalItem,
      "originalItemDescription": record.originalItemDescription,
      "originalUom": record.originalUom,
      "originalPack": record.originalPack,
      "originalSize": record.originalSize,
      "originalBrand": record.originalBrand,
      "originalStorageCode": record.originalStorageCode,
      "ruleType": "neversub",
      "createdByName": userName,
      "createdById": userId,
      "createTimestamp": moment().format(DATE_TIME_TWO_FORMAT),
      "modifiedByName": userName,
      "modifiedById": userId,
      "modifiedTimestamp": moment().format(DATE_TIME_TWO_FORMAT),
      "endDate": null,
      "customerNumber": record.customerNumber ? record.customerNumber : "",
      "customerName": record.customerName ? record.customerName : "",
      "expandedItems": null,
      "callFrom": "ogmSubs",
    }
    onUpdateSubs(args, null, false,null);
  }
  const onUpdateSubs = (formaData, onCloseModal,wasDropout,expandedLength) => {
      const timing = Date.now();
      const args = {...formaData, "customerNumber": formaData.customerNumber ? formaData.customerNumber : "",
        "customerName": formaData.customerName ? formaData.customerName : "",
      "nationalId": formaData.nationalId ? formaData.nationalId : "",
      "nationalName": formaData.nationalName ? formaData.nationalName : "",}
      updateSubstitutionsData(args).then(data => {
        if(wasDropout && args.expandedItems != null) {
          if(expandedLength === null && args.expandedItems.length === 0) {
            message.success(`Deleted Drop out rule Successfully.`);
            //Cot-9714, remove duplicate code
          // }else if(expandedLength === null && args.expandedItems.length > 0 && args.dropOutRuleEndDate === undefined) {
          //   message.success(`Deleted Drop out rule Successfully.`);
          //   message.success(`Updated Substitutions Successfully.`);
          }else if(expandedLength !== null && args.expandedItems.length >= 0 && args.dropOutRuleEndDate === undefined) {
            //message.success(`Deleted Drop out rule Successfully.`); Removed deleted msg because the condition is, dropoutRuleEndDate is undefined and it is not deleted
            message.success(`Updated Substitutions Successfully.`);
          }else{
            message.success(`Updated Substitutions Successfully.`);
          }
        }else{
          message.success(`Updated Substitutions Successfully.`);
        }
        onCloseModal && onCloseModal();
        setPagination({
          pageSize: sessionStorage.getItem('pageSize')?parseInt(sessionStorage.getItem('pageSize'),10):CONST_PAGINATION_TEN.pageSize,
          pageIndex: sessionStorage.getItem('pageIndex')?parseInt(sessionStorage.getItem('pageIndex'),10):CONST_PAGINATION_TEN.pageIndex,
        });
        setResetActivePagination(!resetActivePagination);
      }).catch(err => {
        if(wasDropout && args.expandedItems != null) {
          if(expandedLength === null && args.expandedItems.length === 0) {
            message.error(`Delete Drop out Sub rule Failed, please try again.`);
          }else{
            if(err.isInvalidShipTo) {
              message.error(err.message)
            }else {
              message.error(`Update Substitutions Failed, please try again.`);
            }
          }
        }else{
          if(err.isInvalidShipTo) {
            message.error(err.message)
          }else if(err?.response?.status === 400) {
            message.error(err?.response?.data?.description);
          }else{
            message.error(`Update Substitutions Failed, please try again.`);
          }
        }
      });
      datadogRum.onReady(function(){
        datadogRum.addTiming(`Update Subs`,timing);
      });
    }
  const onDeleteNeverSubs = (args, onCloseModal) => {
    const timing = Date.now();
    let isDropout = false;
    if (editableData !== null && editableData.ruleType === 'dropout') {
      isDropout = true;
    }
    deleteManageSubs(args)
      .then(data => {
        if (isDropout) {
          message.success(`Deleted Drop out rule Successfully.`);
        }
        else {
          message.success(`Deleted Never Sub rule Successfully.`);
        }

        onCloseModal();
        setPagination({
          pageSize: sessionStorage.getItem('pageSize'),
          pageIndex: sessionStorage.getItem('pageIndex'),
        });
        setResetActivePagination(!resetActivePagination);
      })
      .catch(err => {
        if (isDropout) {
          message.error(`Delete Drop out Sub rule Failed, please try again.`);
        }
        else {
          message.error(`Delete Never Sub rule Failed, please try again.`);
        }

      });
    datadogRum.onReady(function () {
      datadogRum.addTiming(`Delete Never Subs`, timing);
    });
  }
  const renderOgmSubsModal = (
    // Hide for Phase 1 Mobile 
    //isMobile ? (<OgmSubsOperateModalMobile />) : (
    <OgmSubsOperateModal
    title={title}
    isModalVisible={isOgmSubsModalVisible}
    footer={false}
    width={1400}
    onToggleModal={() => {onToggleModal(setOgmSubsModalVisible); setEditableData(null);resetRecommendedProducts();resetSubstituteProducts();}}
    cancelText="Reset"
    okText="Save"
    onOk={onUpdateSubs}
    onDelete={onDeleteNeverSubs}
    initValueData={editableData}
    loading={updateSubstitutionsDataPending}
    idle={()=>{notification.warning({
      message: `Idle Time Surpassed 5 minutes`,
      placement:'top',
      duration:0,
    })}}
    
  />
)
    //); Hide for Phase 1 Mobile
  
  return (
    isMobile ? (<OgmSubsMobile />) : (
    <div className="manage-subs-ogm-subs">
      <Spin spinning={exportOgmSubsDataPending}>
      <div className="chart-title font-size-16-bold" style={{ font: "Myriad Bold" }}>Search for Items</div>
      <SearchFiltersPanel searchForm={searchFormCb} originalItemSearchReset={originalItemSearchReset} substituteItemSearchReset={substituteItemSearchReset} searchText={searchText} substituteItemSearch={substituteItemSearch} />
      <div className="flex align-item-center justify-end" style={{ marginBottom: "20px" }}>
        <Button type="link" title={exportOgmSubsDataPending?'Exporting...':"Export"} disabled={ogmSubsData === null || exportOgmSubsDataPending} onClick={onExport}>
          <FontAwesomeIcon icon={faFileExport} color={ogmSubsData ? "#6b6b6c" : "#a1a1a2"} style={{ height: "20px", width: "20px" }} />
          <p style={{ marginTop: "-5px", fontSize: "12px", marginLeft: "-3px", color: (ogmSubsData ? "#6b6b6c" : "#a1a1a2") }}>Export</p>
        </Button>
      </div>
      <CommonTable
        rowKey={record => `${record.site}-${record.nationalId}-${record.customerNumber}-${record.originalItem}-${record.originalUom}`}
        columns={parentColumns}
        tableClassName={ogmSubsData ? "subs-report-table" : ""}
        datasource={ogmSubsData}
        loadingData={fetchOgmSubsDataPending}
        expandedColumns={expandedColumns}
        expandedItemDataKey="expandedItems"
        rowExpandable={rowExpandable}
        paginationStyle={{ textAlign: "right", margin: '16px 0px' }}
        triggerConditions={searchConditionData}
        searchText={searchText}
        substituteItemSearch={substituteItemSearch}
        onFecthData={fetchOgmSubsData}
        onResetStore={resetOgmSubsData}
        scrollStyle={{ x: 'max-content', y: 300 }}
        //paginationSetting={CONST_PAGINATION_TEN}
        paginationSetting={pagination}
        key={location.pathname}
        resetActivePagination={resetActivePagination}
        isOgmSubsTable={true} //COT-9839
        sorting={sorting}
        approvalFlagField="requestApprovalFlag"
      />
       {isOgmSubsModalVisible && renderOgmSubsModal}
       </Spin>
    </div>
    )
  );
};

OgmSubs.propTypes = {};
OgmSubs.defaultProps = {};
//COT-10012,customized sorter
export const CustomerTitle = ({ dataIndex, title,sorting,setSorting }) => {
  return <>
    <span className='customer-title'>
      {title}
      <span className='customer-sort-icon'>
        <Tooltip
          title={
            sorting.sortedBy === dataIndex && sorting.sort === 'ascend'
              ? 'Click to cancel ascending'
              : 'Ascend'
          }
        >
          <CaretUpOutlined
            style={{
              margin: '0 4px',
              color: sorting.sortedBy === dataIndex && sorting.sort === 'ascend' ? '#1890ff' : undefined,
              cursor: 'pointer',
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (sorting.sortedBy === dataIndex && sorting.sort === 'ascend') {
                setSorting({ sortedBy: null, sort: null })
              } else {
                setSorting({ sortedBy: dataIndex, sort: 'ascend' })
              }
            }}
          />
        </Tooltip>
        <Tooltip
          title={
            sorting.sortedBy === dataIndex && sorting.sort === 'descend'
              ? 'Click to cancel descending'
              : 'Descend'
          }
        >
          <CaretDownOutlined
            style={{
              color: sorting.sortedBy === dataIndex && sorting.sort === 'descend' ? '#1890ff' : undefined,
              cursor: 'pointer',
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (sorting.sortedBy === dataIndex && sorting.sort === 'descend') {
                setSorting({ sortedBy: null, sort: null })
              } else {
                setSorting({ sortedBy: dataIndex, sort: 'descend' })
              }
            }}
          />
        </Tooltip></span>
    </span></>
}
